import { Serializable } from '@/models/core/serializable';
import { Student } from '@/models/student/student';

export class StudentDraggableExtraArea implements Serializable<StudentDraggableExtraArea> {
  deleteStudents: Student[] = [];
  noAssignStudents1: Student[] = [];
  noAssignStudents2: Student[] = [];
  noAssignStudents3: Student[] = [];
  noAssignStudents4: Student[] = [];

  get noAssignStudents(): Student[] {
    return [...this.noAssignStudents1, ...this.noAssignStudents2, ...this.noAssignStudents3, ...this.noAssignStudents4];
  }

  deserialize(input: any): StudentDraggableExtraArea {
    return this;
  }

  assignStudents(value: Student[]) {
    // 最も割り当て生徒の少ない作業領域に割り当てる
    let noAssignStudents: Student[] = [this.noAssignStudents1, this.noAssignStudents2, this.noAssignStudents3, this.noAssignStudents4].sort((a: Student[], b: Student[]) => {
      return a.length > b.length ? 1 : -1;
    })[0];

    switch (noAssignStudents.length) {
      case this.noAssignStudents1.length:
        this.noAssignStudents1 = this.noAssignStudents1.concat(value);
        break;
      case this.noAssignStudents2.length:
        this.noAssignStudents2 = this.noAssignStudents2.concat(value);
        break;
      case this.noAssignStudents3.length:
        this.noAssignStudents3 = this.noAssignStudents3.concat(value);
        break;
      case this.noAssignStudents4.length:
        this.noAssignStudents4 = this.noAssignStudents4.concat(value);
        break;
    }
  }

  clean() {
    this.deleteStudents = [];
    this.noAssignStudents1 = [];
    this.noAssignStudents2 = [];
    this.noAssignStudents3 = [];
    this.noAssignStudents4 = [];
  }
}
